import Header from "./../../../Headers/HeaderForAreLoggedIn/index.vue"
import Footer from "./../../../Footers/Footer/index.vue"
import ProgressHUD from "./../../../ProgressHUD/index.vue"
import QuestionsAnswersPrivate from "./../../Widget/QuestionsAnswersPrivate/index.vue"
import ReputationShow  from "./../../Widget/ReputationData/ReputationShow.vue"
import Api from "./../../../../services/api"

export default {
  name: "ProductPrivate",
  props: [],
  components: {
    Header,
    Footer,
    ProgressHUD,
    QuestionsAnswersPrivate,
    ReputationShow,
  },
  mounted() {},
  data() {
    return {
      product: {
        _id: "",
        name: "",
        description: "",
        specs: "",
        price: "",
        type: "",
        details: {
          number: "",
          weight: "",
          shipping: "",
          manufacture: "",
          asin: "",
        },
        images: [""],
        available: 0,
        accept: true,
      },
      reviews: [],
      comment: [],
      itemCount: 1,
      validationMessage: null,
      curentImage: ''
    }
  },
  methods: {
    minusItem() {
      if (this.itemCount > 1) {
        this.itemCount--
      }
    },
    plusItem() {
      if (this.itemCount < this.product.available) {
        this.itemCount++
      }
    },
    buyNow() {
      var itemForBasket = {
        product: this.product,
        quantity: this.itemCount,
      }

      this.$store.commit("addOrEditItem", itemForBasket)
      this.$router.push("/checkout")
    },
    goToEditPage: function(product) {
      this.$router.push("/product/edit/" + product._id)
    },
  },
  computed: {},
  beforeCreate() {},
  async created() {
    var response = await Api.getProductById(this.$route.params.id)

    if (response.data && !response.data.error) {
      this.product = response.data.results.product
      this.reviews = response.data.results.opinion
      this.comment = response.data.results.comment
      this.curentImage = this.product.images[0];
    } else {
      this.validationMessage = "Something went wrong."
      console.error("Something went wrong.")
    }

    this.$refs.progress.hide()
  },
  mounted() {
    $(".modal").modal()
    $("select").material_select()
  },
}



// WEBPACK FOOTER //
// ./src/components/Marketplace/Product/Private/ProductPrivate.component.js